jQuery(document).ready(function($) {
  var type = "LEGAL_ENTITY";
  $('.trust-deed').hide(0);

  $('#rlei-entity-type').on('change', function(e) {
    type = $(this).val();

    if (type === 'TRUST') {
      // $('#rlei-company-name_field').hide(0);
      $('#rlei-company-id_field').hide(0);
      $('.trust-deed').show(0);
      $('body').find('#rlei-company-name').val();
      $('body').find('#rlei-company-data').html('');
    } else if (type === 'FUND' || type === 'OTHER') {
      $('#rlei-company-id_field').show(0);
      $('.trust-deed').show(0);
      $('body').find('#rlei-company-name').val();
      $('body').find('#rlei-company-data').html('');
    } else {
      $('#rlei-company-id_field').show(0);
      $('.trust-deed').hide(0);
    }
  });

  $('body').on('click', '.rlei-ch-item', function(e) {
    e.preventDefault();
    $('#rlei-company-name').val($(this).data('company'));
    $('#rlei-company-id').val($(this).data('company-number'));
    $('#rlei-company-data').html('');
  });

  $('#rlei-company-name').on('keyup', function(e) {
    e.preventDefault();

    if ($('#entity_country').val() === "GB") {
      console.log(type);
      if (type !== 'TRUST' || type === 'FUND' || type === 'OTHER') {
        if ($(this).val().length > 3) {
          setTimeout(do_api_call($(this).val()), 200);
        }
      }
    }
  });

  $('#entity_country').change(function () {
    $('body').trigger('update_checkout');
  });

  function do_api_call(value) {
    var data = {
      q: value
    };

    console.log('lol');

    $.post(rleiajax.url, data, function(data, status) {
      $('#rlei-company-data').html('<div id="rlei-company-data-insert"></div>');

      if (data) {
        var search_data = JSON.parse(data);
        
        $.each(search_data.items, function(index, el) {
          $('#rlei-company-data-insert').append('<a href="#" class="rlei-ch-item" data-company="'+el.title+'" data-company-number="'+el.company_number+'"><strong>'+el.title+'</strong><br/><span class="rlei-ch-company">'+el.company_number+'</span></a>');
        });
      }
    });
  }
});